import { httpDataForm, requestServer } from "@/service/api/network"
import { regexCarNumber } from "@/service/utils/useful"

export default {
  namespaced: true,
  state: {
    carNumber: "",
    isCarChecked: false,
  },
  mutations: {
    SET_CARNUMBER: (state: any, payload: string) => {
      state.carNumber = payload
    },
    SET_ISCARCHECKED: (state: any, payload: boolean) => {
      state.isCarChecked = payload
    },
  },
  actions: {
    checkCarNumberForm: ({ dispatch }: any, payload: string) => {
      return !regexCarNumber(payload)
        ? dispatch(
            "warning/openWarning",
            {
              message: "지원하지 않는 형식의 차량 번호입니다.\n차량 번호를 다시 입력해주세요.",
              buttonText: "다시 입력하기",
            },
            { root: true }
          )
        : true
    },
    checkCarNumber: async ({ commit, dispatch }: any, payload: string) => {
      const isCarNumberFormOK = await dispatch("checkCarNumberForm", payload)
      let warningMessage: string = ""
      if (isCarNumberFormOK) {
        try {
          const { data }: any = await requestServer(httpDataForm("020012", payload))
          return data.Header.ErrCode === "000000"
            ? data.Body.CarNums === null
              ? (warningMessage = "등록되지 않은 차량입니다.\n차량 번호를 다시 확인해주세요!")
              : data.Body.CarNums[0].IsMe
              ? (warningMessage = "나 자신을 호출할수 없습니다")
              : commit("SET_ISCARCHECKED", true)
            : (warningMessage = data.Header.ErrMsg)
        } catch (e: any) {
          return (warningMessage = e.ErrMsg)
        } finally {
          if (warningMessage) {
            dispatch("warning/openWarning", { message: warningMessage, buttonText: "확인" }, { root: true })
          }
        }
      }
    },
  },
}
